import { useContext } from "react";
import { AuthContext } from "@/context/AuthContext";
import { decodeToken } from "@/services/AuthService";

interface UserData {
	username: string;
	userId: string;
}

export function useGetUserDataFromToken(): UserData | null {
	const authContext = useContext(AuthContext);

	if (!authContext || !authContext.accessToken) {
		return null;
	}

	const { client_id, username } = decodeToken(authContext.accessToken);

	return { username, userId: `user_id_${client_id}` };
}
